import React, { useState } from 'react';

import cn from 'classnames';
import { motion } from 'framer-motion';
import DOMPurify from 'isomorphic-dompurify';

import { descriptionVariants, framerCommon, imageVariants, titleVariants } from '../../framer.variants';
// import UseCaseAccordion from './accordion';
import { data_use_cases } from './content';

export default function UseCases({ id }) {
  const [expanded, setExpanded] = useState(false);
  const { prefix, title, items } = data_use_cases;

  return (
    <section id={id} className="gl-wrapper bg-black pb-[80px] pt-[120px] sm:py-[48px]">
      <div className="flex flex-col gap-[56px] sm:gap-5">
        <p className="gl-heading-3 gl-prefix-line mt-2 text-white">{prefix}</p>
        <h2
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
          className="gl-heading-2 text-white [&>span]:text-demo-sa-green"
        />
      </div>
      <div className="mt-11 flex flex-col lg:mt-8">
        {items.map((item, idx) => (
          <div
            key={item.id}
            className={cn(
              'instance flex items-start gap-11 overflow-hidden border-y border-y-[#438E61] py-9 text-white even:flex-row-reverse 1300:gap-8 lg:gap-6 lg:even:flex-col sm:flex-col sm:py-6',
              items.length > 1 && idx !== 0 && 'border-t-transparent',
              idx === 0 && 'border-t-transparent !pt-0',
              idx === items.length - 1 && 'border-b-transparent !pb-0',
            )}
          >
            <div className="relative flex flex-col gap-[44px] sm:gap-5">
              <motion.h3
                {...framerCommon}
                transition={{ duration: 1, delay: 0 }}
                variants={{ hidden: { y: '-100%' }, visible: { y: 0 } }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.title) }}
                className="gl-heading-3 relative mb-[0.75rem] leading-[1.12] text-white lg:!transform-none"
              />
              <motion.div
                {...framerCommon}
                transition={{ duration: 1, delay: 0 }}
                variants={{ hidden: { y: '50%' }, visible: { y: 0 } }}
                className="description relative flex flex-col gap-[2.25rem] lg:!transform-none [&>a]:underline"
              >
                {item.content.map(({ title, description }) => (
                  <div key={title}>
                    <h3 className="font-Proxima text-b-sm font-black uppercase">{title}</h3>
                    <p>{description}</p>
                  </div>
                ))}
              </motion.div>
            </div>
            <motion.img
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0 }}
              variants={imageVariants(idx % 2 === 0)}
              className="relative max-w-[50%] object-contain lg:!right-0 sm:max-w-full"
              src={item.image}
              alt=""
            />
          </div>
        ))}
      </div>

      {/*      <div className="mt-11 lg:mt-8">
        {items.map((item, i) => (
          <UseCaseAccordion
            key={item.title}
            item={item}
            items={items}
            i={i}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </div>*/}
    </section>
  );
}
